import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "nav nav-tabs" }
const _hoisted_3 = { class: "nav-item" }
const _hoisted_4 = { class: "nav-item" }
const _hoisted_5 = { class: "nav-item" }
const _hoisted_6 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_7 = {
  key: 1,
  class: "nav-item"
}

import { ref } from "vue";
import { Permission } from "../../utils/Permission";

export default /*#__PURE__*/_defineComponent({
  __name: 'TabContainer',
  emits: ["on-change-page"],
  setup(__props, { emit }) {



const isBlocklyActive = ref(true);
const isCodeActive = ref(false);
const isHtmlActive = ref(false);
const isDynamicDomScriptActive = ref(false);
const isBlocklyXMLActive = ref(false);

const allClear = () => {
  isBlocklyActive.value = false;
  isCodeActive.value = false;
  isHtmlActive.value = false;
  isDynamicDomScriptActive.value = false;
  isBlocklyXMLActive.value = false;
};
const toBlockly = () => {
  allClear();
  isBlocklyActive.value = true;
  emit("on-change-page", "blockly");
};
const toCode = () => {
  allClear();
  isCodeActive.value = true;
  emit("on-change-page", "code");
};
const toHtml = () => {
  allClear();
  isHtmlActive.value = true;
  emit("on-change-page", "html");
};
const toDynamicDomScript = () => {
  allClear();
  isDynamicDomScriptActive.value = true;
  emit("on-change-page", "dynamicDomScript");
};
const toBlocklyXML = () => {
  allClear();
  isBlocklyXMLActive.value = true;
  emit("on-change-page", "blocklyXml");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", _hoisted_3, [
        _createElementVNode("button", {
          class: _normalizeClass(["nav-link", { active: isBlocklyActive.value }]),
          "data-toggle": "tab",
          active: "",
          onClick: toBlockly
        }, " BLOCK ", 2)
      ]),
      _createElementVNode("li", _hoisted_4, [
        _createElementVNode("button", {
          id: "code_tbuttonb",
          class: _normalizeClass(["nav-link", { active: isCodeActive.value }]),
          "data-toggle": "tab",
          onClick: toCode
        }, " CODE ", 2)
      ]),
      _createElementVNode("li", _hoisted_5, [
        _createElementVNode("button", {
          class: _normalizeClass(["nav-link", { active: isHtmlActive.value }]),
          "data-toggle": "tab",
          onClick: toHtml
        }, " HTML ", 2)
      ]),
      (_unref(Permission).onlyAdmin)
        ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
            _createElementVNode("button", {
              class: _normalizeClass(["nav-link", { active: isDynamicDomScriptActive.value }]),
              "data-toggle": "tab",
              onClick: toDynamicDomScript
            }, " Dynamic Dom Script ", 2)
          ]))
        : _createCommentVNode("", true),
      (_unref(Permission).onlyAdmin)
        ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
            _createElementVNode("button", {
              class: _normalizeClass(["nav-link", { active: isBlocklyXMLActive.value }]),
              "data-toggle": "tab",
              onClick: toBlocklyXML
            }, " Blockly XML ", 2)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})